
//
// Uploaders:
//
// https://www.npmjs.com/search?q=file+uploader
// https://www.npmjs.com/search?ranking=optimal&q=file%20uploader
// https://www.npmjs.com/search?q=file%20uploader&ranking=quality
// https://www.npmjs.com/package/@uppy/provider-views
// https://www.npmjs.com/search?q=keywords:file%20uploader
// https://www.npmjs.com/package/react-fine-uploader#gallery-
// DEMO: https://navjobs.github.io/upload/

import FileInput from "react-md/lib/FileInputs/FileInput";
import Button from "react-md/lib/Buttons/Button";
import {FontIcon} from "react-md";
import {Uploader, UploadField, UploadRequest} from "@navjobs/upload";
import React, {Component} from "react";
import {concat} from "lodash";
import * as RequestAttachmentUploader from "./RequestAttachmentUploader";

function log()
{
    console.log.apply( null, concat( ['%cFileUploader', 'color:blue'], arguments ));
}

export class FileUploader extends Component
{
    state = {

        // After uploading one file this uploader does no allow uploading other file.
        // Oficial reset method does not work (https://github.com/navjobs/upload/issues/21).
        // Component needs to be temporarily removed and created again.
        reloadUploader: false

    };

    render()
    {
            const { requestIdentifier, request, getRequestById } = this.props;

            const children = (
                <div>
                    <Button
                        raised
                        className="btn btn-primary touchButton-3"
                        style={{ margin: 0, width: '100%' }}
                    >
                        <div>
                            <FontIcon style={{ style: '#000', display: 'inline-block' }}>file_upload</FontIcon>
                        </div>
                    </Button>
                </div>
            );

            const accept = RequestAttachmentUploader.getFileMaskForFileSelection();
            const onComplete = async ( onCompleteInfo ) => {
                const { response, status } = onCompleteInfo;
                await RequestAttachmentUploader.onFileUploadedSuccess({ http: { response, status }, dataForRefresh:{ requestIdentifier, getRequestById }});
                this.setState({ reloadUploader: true });
            };
            const onError = (a,b,c,d,e) =>
            {
                //
                // This uploader has no error message!
                //
                log( 'onError', a,b,c,d,e );
                alert( 'Nepodařilo se uložit soubor' );
                this.setState({ reloadUploader: true });
            };
            const uploaderHttpRequest = RequestAttachmentUploader.getHttpRequestDataForFileUploader({ requestIdentifier });

            log( 'render', { uploaderHttpRequest, request, accept });

            if( this.state.reloadUploader )
            {
                    return (<div />);
            }
            else
            {
                    return (
                        <div id={"uploader"}>
                            <Uploader
                                request={uploaderHttpRequest}
                                onComplete={onComplete}
                                onError={onError}
                                uploadOnSelection
                            >
                                {({ onFiles, progress, complete, x, y, z }) => {
                                    log('inner component', {onFiles, progress, complete, x, y, z});
                                    return (
                                        <div className="fileUploader">
                                            <UploadField onFiles={onFiles} uploadProps={{ accept }}>
                                                {children}
                                            </UploadField>
                                            {progress &&
                                            <progress className="progress" max="100" value={complete ? 100 : progress - 10} />}
                                        </div>
                                    )
                                }}
                            </Uploader>
                        </div>
                    );
            }
    }

    componentDidUpdate()
    {
        if( this.state.reloadUploader )
        {
            this.setState({ reloadUploader: false });
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/RequestDetail/FileUploader.js